import React from 'react';
import './Home.css';

function Home() {
  return (
    <div className="home-container">
      <h2>Welcome to Matt's Digital Playground</h2>
      <p>This site is a work in progress - check back soon for updates!</p>
      
      <div className="utilities-section">
        <h3>Available Utilities</h3>
        <div className="utility-card">
          <h4>QR Code Generator</h4>
          <p>Generate QR codes for any URL or create specialized CNIC form QR codes.</p>
          <a href="/utils/QRGenerator" className="utility-link">Go to QR Generator →</a>
        </div>
      </div>
    </div>
  );
}

export default Home;